import { formatDateSeparator } from '@teo/widget-shared';
import { useWidget } from '../context/WidgetContext.js';

type DateSeparatorProps = {
  dateKey: string;
};

export function DateSeparator({ dateKey }: DateSeparatorProps) {
  const { locale, t } = useWidget();
  const label = formatDateSeparator(dateKey, locale, {
    today: t.today,
    yesterday: t.yesterday,
  });

  return (
    <div className="teo-date-separator" role="separator" aria-label={label}>
      {label}
    </div>
  );
}
